module.exports = __webpack_public_path__ + "static/img/search-icon-button-755412-3180392.0056f91d.png";